var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.703 31.545a6.02 6.02 0 01-3.248-3.248l.462-.192A5.482 5.482 0 01.5 26v-5H0V11h.5V6c0-.747.149-1.457.417-2.105l-.462-.192A6.02 6.02 0 013.703.455l.192.462A5.482 5.482 0 016 .5h4V0h8v.5h8V0h8v.5h8V0h8v.5h8V0h8v.5h4c.747 0 1.457.149 2.105.417l.192-.462a6.02 6.02 0 013.248 3.248l-.462.192c.269.648.417 1.358.417 2.105v5h.5v10h-.5v5c0 .747-.148 1.457-.417 2.105l.462.192a6.02 6.02 0 01-3.248 3.248l-.192-.462A5.482 5.482 0 0170 31.5h-4v.5h-8v-.5h-8v.5h-8v-.5h-8v.5h-8v-.5h-8v.5h-8v-.5H6a5.483 5.483 0 01-2.105-.417l-.192.462z",
    fill: "#FBFBFB",
    stroke: "#D5D5D5",
    strokeDasharray: "8 8"
  })));
}
export default SvgDriverSeat;